import { render } from "./TheJobs.vue?vue&type=template&id=bfc44e9a&scoped=true"
import script from "./TheJobs.vue?vue&type=script&lang=js"
export * from "./TheJobs.vue?vue&type=script&lang=js"

import "./TheJobs.vue?vue&type=style&index=0&id=bfc44e9a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc44e9a"]])

export default __exports__